export const CONTRACT_CODE_OPTIONS = [
  {
    value: "01.CIFRA - ESCRITÓRIO OLINDA",
    label: "01.CIFRA - ESCRITÓRIO OLINDA",
  },
  {
    value: "03.CIFRA - CENTRO DE DIST - GUABIRABA",
    label: "03.CIFRA - CENTRO DE DIST - GUABIRABA",
  },
  {
    value: "04.CIFRA - TORRE TI",
    label: "04.CIFRA - TORRE TI",
  },
  {
    value: "FUNDARPE GINASIO PERNAMBUCANO",
    label: "FUNDARPE GINASIO PERNAMBUCANO",
  },
  {
    value: "SUAPE",
    label: "SUAPE",
  },
  {
    value: "PREFEITURA DE BELO JARDIM",
    label: "PREFEITURA DE BELO JARDIM",
  },
  {
    value: "COMPANHIA SANEAMENTO DE ALAGOAS - CASAL",
    label: "COMPANHIA SANEAMENTO DE ALAGOAS - CASAL",
  },
  {
    value: "FUNDARPE (MAC)",
    label: "FUNDARPE (MAC)",
  },
  {
    value: "CRECHE CYRO DE ANDRADE",
    label: "CRECHE CYRO DE ANDRADE",
  },
  {
    value: "BRK AL PAVIMENTAÇÃO (COMERCIAL)",
    label: "BRK AL PAVIMENTAÇÃO (COMERCIAL)",
  },
  {
    value: "BRK AL FISCALIZAÇÃO",
    label: "BRK AL FISCALIZAÇÃO",
  },
  {
    value: "BRK AL PAVIMENTAÇÃO CALÇADA (OPERACIONAL)",
    label: "BRK AL PAVIMENTAÇÃO CALÇADA (OPERACIONAL)",
  },
  {
    value: "BRK AL - HIDROMETRO (NOVO)",
    label: "BRK AL - HIDROMETRO (NOVO)",
  },
  {
    value: "IGUA - CADASTRO",
    label: "IGUA - CADASTRO",
  },
  {
    value: "IGUA - PROJETO SE LIGA",
    label: "IGUA - PROJETO SE LIGA",
  },
  {
    value: "IGUA - HIDROMETRO",
    label: "IGUA - HIDROMETRO",
  },
  {
    value: "IGUA - CORTE E RELIGAÇÃO",
    label: "IGUA - CORTE E RELIGAÇÃO",
  },
  {
    value: "IGUA - INSTALAÇÃO DE SENSORES",
    label: "IGUA - INSTALAÇÃO DE SENSORES",
  },
  {
    value: "IGUA - SONDAGEM",
    label: "IGUA - SONDAGEM",
  },
  {
    value: "IGUA - RECADASTRAMENTO",
    label: "IGUA - RECADASTRAMENTO",
  },
  {
    value: "IGUA - RECADASTRAMENTO FTE",
    label: "IGUA - RECADASTRAMENTO FTE",
  },
  {
    value: "FUNDARPE - MUSEU DO TREM",
    label: "FUNDARPE - MUSEU DO TREM",
  },
  {
    value: "AEGEA",
    label: "AEGEA",
  },
  {
    value: "PREFEITURA DE IPOJUCA",
    label: "PREFEITURA DE IPOJUCA",
  },
  {
    value: "SERRA TALHADA",
    label: "SERRA TALHADA",
  },
  {
    value: "VERDE ALAGOAS",
    label: "VERDE ALAGOAS",
  },
  {
    value: "CEASA",
    label: "CEASA",
  },
  {
    value: "REQUALIFICAÇÃO DRM",
    label: "REQUALIFICAÇÃO DRM",
  },
  {
    value: "CONSÓRCIO DRM",
    label: "CONSÓRCIO DRM",
  },
  {
    value: "SUBSTITUIÇÃO DE HIDROMETROS",
    label: "SUBSTITUIÇÃO DE HIDROMETROS",
  },
  {
    value: "RECUPERAÇÃO DE DÉBITO",
    label: "RECUPERAÇÃO DE DÉBITO",
  },
  {
    value: "CADASTRO DRI",
    label: "CADASTRO DRI",
  },
  {
    value: "COBRANCA ADMINISTRATIVA (REC DE DEBITOS)",
    label: "COBRANCA ADMINISTRATIVA (REC DE DEBITOS)",
  },
];

export const CONTRACT_CLIENT_OPTIONS = [
  {
    value: "compesa",
    label: "Compesa",
  },
  {
    value: "igua",
    label: "Iguá",
  },
  {
    value: "deso",
    label: "Deso",
  },
  {
    value: "brk",
    label: "BRK",
  },
  {
    value: "verdeAlagoas",
    label: "Verde Alagoas",
  },
  {
    value: "casal",
    label: "Casal",
  },
  {
    value: "aegea",
    label: "Aegea",
  },
  {
    value: "obras",
    label: "Obras",
  },
];

export const CONTRACT_STATE_OPTIONS = [
  "Pernambuco",
  "Sergipe",
  "Alagoas",
  "Piauí",
];

export const CONTRACT_STATUS_OPTIONS = ["Ativo", "Inativo"];
